import { Box, Container, VStack, HStack, Text, Avatar } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const testimonials = [
  {
    name: 'Priya S.',
    role: 'AI Developer @ Fintech Startup',
    image: 'https://i.pravatar.cc/150?img=1',
    quote: "I went from zero to shipping production apps. My first interview, they asked to see my portfolio. I showed 5 real projects. Got the offer on the spot.",
    highlight: '₹18L starting salary'
  },
  {
    name: 'Rahul M.',
    role: 'ML Engineer @ Tech Company',
    image: 'https://i.pravatar.cc/150?img=2',
    quote: "Not a CS grad. Learned Python on YouTube before this. The idea2app method changed everything. Built stuff that actually works.",
    highlight: 'Zero to offer in 5 months'
  },
  {
    name: 'Ananya K.',
    role: 'AI Engineer @ Startup',
    image: 'https://i.pravatar.cc/150?img=3',
    quote: "Thought AI was too hard. But the way they break it down step-by-step... I actually understood why things work, not just copy-paste.",
    highlight: 'Now mentoring others'
  },
  {
    name: 'Vikram P.',
    role: 'GenAI Developer @ Product Company',
    image: 'https://i.pravatar.cc/150?img=4',
    quote: "The real game-changer was CodeverseMentor. Coding alone felt stuck. Having a guide that doesn't just give answers... game-changing.",
    highlight: '₹22L package'
  },
  {
    name: 'Neha D.',
    role: 'AI Engineer @ FAANG',
    image: 'https://i.pravatar.cc/150?img=5',
    quote: "24 weeks felt tight. But the structure is insane. By week 8, I had projects I was proud of. Interview prep was smooth.",
    highlight: 'FAANG offer + referrals'
  },
  {
    name: 'Arjun K.',
    role: 'Self-Employed AI Dev',
    image: 'https://i.pravatar.cc/150?img=6',
    quote: "Didn't want a job. Built my own AI SaaS. This course taught me how to think like an engineer. Now doing ₹4L/month.",
    highlight: 'Building own product'
  },
];

const TestimonialCard = ({ testimonial }) => (
  <Box
    bg="white"
    p={6}
    borderRadius="lg"
    boxShadow="0 4px 12px rgba(0, 0, 0, 0.08)"
    minW={{ base: '90vw', md: '400px' }}
    flexShrink={0}
  >
    <VStack spacing={4} align="start" h="full">
      {/* Quote */}
      <Text fontSize="sm" color="gray.700" fontStyle="italic" lineHeight="1.6">
        "{testimonial.quote}"
      </Text>

      {/* Highlight Badge */}
      <Box
        bg="accent.gold"
        color="black"
        px={3}
        py={1}
        borderRadius="full"
        fontSize="xs"
        fontWeight="700"
      >
        {testimonial.highlight}
      </Box>

      {/* Author */}
      <HStack spacing={3} pt={2} mt="auto">
        <Avatar
          name={testimonial.name}
          src={testimonial.image}
          size="sm"
        />
        <VStack spacing={0} align="start">
          <Text fontSize="sm" fontWeight="700" color="brand.800">
            {testimonial.name}
          </Text>
          <Text fontSize="xs" color="gray.600">
            {testimonial.role}
          </Text>
        </VStack>
      </HStack>
    </VStack>
  </Box>
);

const GetHiredTestimonials = () => {
  return (
    <Box py={{ base: 8, md: 12 }} bg="gray.50">
      <Container maxW="100%">
        <VStack spacing={8}>
          <VStack spacing={2} align="center" textAlign="center">
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              fontWeight="700"
              color="brand.800"
            >
              Join 300+ who've already landed AI jobs
            </Text>
            <Text fontSize="sm" color="gray.600">
              Real students. Real outcomes. Scroll to see.
            </Text>
          </VStack>

          {/* Marquee Container */}
          <Box
            w="full"
            overflow="hidden"
            position="relative"
            _before={{
              content: '""',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              w: '40px',
              bg: 'linear-gradient(to right, rgba(249, 250, 251, 1), rgba(249, 250, 251, 0))',
              zIndex: 10,
            }}
            _after={{
              content: '""',
              position: 'absolute',
              right: 0,
              top: 0,
              bottom: 0,
              w: '40px',
              bg: 'linear-gradient(to left, rgba(249, 250, 251, 1), rgba(249, 250, 251, 0))',
              zIndex: 10,
            }}
          >
            <MotionBox
              display="flex"
              gap={4}
              animate={{ x: ['0%', '-100%'] }}
              transition={{
                duration: 20,
                repeat: Infinity,
                repeatType: 'loop',
                ease: 'linear',
              }}
              px={4}
            >
              {/* First set */}
              {testimonials.map((testimonial, idx) => (
                <TestimonialCard key={`first-${idx}`} testimonial={testimonial} />
              ))}
              {/* Duplicate for seamless loop */}
              {testimonials.map((testimonial, idx) => (
                <TestimonialCard key={`second-${idx}`} testimonial={testimonial} />
              ))}
            </MotionBox>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
};

export default GetHiredTestimonials;
